import { Directive, forwardRef } from '@angular/core';
import {
  NG_VALIDATORS,
  Validator,
  FormGroup,
  ValidationErrors
} from '@angular/forms';

@Directive({
  selector: '[hasOneSelected]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => HasOneSelectedValidatorDirective),
      multi: true
    }
  ]
})
export class HasOneSelectedValidatorDirective implements Validator {
  validate(group: FormGroup): ValidationErrors | null {
    let errors = {};
    const keys = Object.keys(group.value);
    for (let key of keys) {
      if (!!group.value[key]) {
        return null;
      } else {
        errors[key] = true;
      }
    }
    return errors;
  }
}
